import React, { useMemo } from 'react';
import { bool, string, func, array, arrayOf, shape, object, oneOfType } from 'prop-types';
import { Field, Form as FinalForm } from 'react-final-form';
import Form from '../Form/Form';
import css from './CustomRadioButton.module.css';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';

function CustomRadioButton(props) {
  const {
    withForm,
    onChange,
    name,
    radioInputClassName,
    radioSelectedInputClassName,
    formRootClassName,
    formClassName,
    radioValues,
    disabled,
    userNativeLang,
    values = {},
    ...restProps
  } = props;

  const classes = classNames(css.formRoot || formRootClassName, formClassName, {
    [css.disabledForm]: !withForm && disabled,
  });
  const fieldSelectedValue = values[name];
  const radioBtnProps = {
    name,
    component: 'input',
    type: 'radio',
  };

  const allowedRadioValues = useMemo(() => radioValues.map(option => option.value.toString()), []);

  const handleOnChange = e => {
    e.preventDefault();
    if (disabled) return;
    if (typeof onChange === 'function') {
      const strValue = e.target.value;
      if (!allowedRadioValues.includes(strValue)) return;
      onChange(strValue);
    }
  };

  const handleFormSubmit = values => {
    if (typeof onChange === 'function') {
      onChange(values);
    }
  };

  return withForm ? (
    <FinalForm
      {...restProps}
      name={name}
      onSubmit={handleFormSubmit}
      handleFormSubmit={handleFormSubmit}
      radioInputClassName={radioInputClassName}
      radioSelectedInputClassName={radioSelectedInputClassName}
      formRootClassName={classes}
      radioValues={radioValues}
      allowedRadioValues={allowedRadioValues}
      render={formProps => {
        const {
          handleSubmit,
          handleFormSubmit,
          name,
          values,
          form,
          radioValues,
          radioInputClassName,
          radioSelectedInputClassName,
          formRootClassName,
          allowedRadioValues,
        } = formProps;
        const selectedValue = values[name];

        const handleOnChange = e => {
          const strValue = e.target.value;
          if (!allowedRadioValues.includes(strValue)) return;
          form.change(name, strValue);
          // handleSubmit(e);
          handleFormSubmit({ [name]: strValue });
        };

        return (
          <Form onSubmit={e => e.preventDefault()} className={formRootClassName}>
            {radioValues.map((option, indx) => {
              const formId = `${name}-${option.value}-${indx}`;
              const classes = classNames(css.input, radioInputClassName, {
                [css.selectedInput]: selectedValue === option.value,
                [radioSelectedInputClassName]:
                  selectedValue === option.value && !!radioSelectedInputClassName,
              });
              const label =
                typeof option.label === 'object'
                  ? option.label[userNativeLang] ?? option.label.toString()
                  : option.label;

              return (
                <label key={formId} htmlFor={formId} className={classes}>
                  <Field
                    {...radioBtnProps}
                    id={formId}
                    value={option.value}
                    onChange={handleOnChange}
                  />
                  <span className={css.text}>{label}</span>
                </label>
              );
            })}
          </Form>
        );
      }}
    />
  ) : (
    <div className={classes}>
      {radioValues.map((option, indx) => {
        const formId = `${name}-${option.value}-${indx}`;
        const classes = classNames(css.input, radioInputClassName, {
          [css.selectedInput]: fieldSelectedValue === option.value,
          [radioSelectedInputClassName]:
            fieldSelectedValue === option.value && !!radioSelectedInputClassName,
        });
        const label =
          typeof option.label === 'object'
            ? option.label[userNativeLang] ?? option.label.toString()
            : option.label;
        return (
          <label key={formId} htmlFor={formId} className={classes}>
            <Field
              {...radioBtnProps}
              id={formId}
              value={option.value}
              onChange={handleOnChange}
              disabled={disabled}
            />
            <span className={css.text}>{label}</span>
          </label>
        );
      })}
    </div>
  );
}

CustomRadioButton.defaultProps = {
  withForm: true,
  name: '',
  radioValues: [],
  radioInputClassName: null,
  radioSelectedInputClassName: null,
  formRootClassName: null,
  formClassName: null,
  disabled: false,
  onChange: null,
};

CustomRadioButton.propTypes = {
  withForm: bool.isRequired,
  name: string.isRequired,
  onChange: func,
  radioInputClassName: string,
  radioSelectedInputClassName: string,
  formRootClassName: string,
  formClassName: string,
  radioValues: arrayOf(
    shape({ value: string.isRequired, label: oneOfType([string, object]).isRequired }).isRequired
  ).isRequired,
  values: object,
  disabled: bool.isRequired,
};

const mapStateToProps = state => {
  const { userNativeLang } = state.UI;
  return { userNativeLang };
};

export default compose(
  connect(
    mapStateToProps,
    null
  )
)(CustomRadioButton);
